import { inject, Injectable } from '@angular/core';
import { AgentAvailability } from '@aaa/interface-agentScheduler';
import { Observable } from 'rxjs';
import { collection, collectionData, Firestore } from '@angular/fire/firestore';
import { WindowRefService } from '../../share/services/window-ref.service';

@Injectable({ providedIn: 'root' })
export class FirestoreConnectorService {
  firestore = inject(Firestore);
  windowRef = inject(WindowRefService);

  availability$: Observable<AgentAvailability[]>;

  constructor() {
    // Todo: need to test
    // this.availabilityRef = this.afs
    //   .collection('wss-aaa-web')
    //   .doc(this.windowRef.nativeWindow.metaData.clubId)
    //   .collection('apps')
    //   .doc('agent-scheduler')
    //   .collection('data')
    //   .doc('gcf')
    //   .collection('availability');
    //
    // this.availability$ = this.availabilityRef.valueChanges();
    const availabilityCollection = collection(
      this.firestore,
      `wss-aaa-web/${this.windowRef.clubId}/apps/agent-scheduler/data/gcf/availability`,
    );

    this.availability$ = collectionData(availabilityCollection) as Observable<AgentAvailability[]>;
  }
}
